<template>
<div class="employee-view">
    <b-overlay
      :show="loading"
      rounded="sm"
      spinner-variant="success"
      spinner-type="grow"
    >
      <div class="employee-wrapper">
        <div v-if="employeeData && employeeData.length > 0">
          <div
            class="employee-item my-3 p-3 font-jumperlight"
            v-for="(item, index) in employeeData"
            :key="'employeeViewItem' + index"
          >
            <div
              class="row employees"
              :class="{ activated: item.activated }"
            >
<!--              <div class="col-3 col-md-2">-->
<!--              <span-->
<!--                class="rounded-employee-icon text-uppercase text-nowrap"-->
<!--                :style="'background-color:' + getColorByExitType(item.exitType)"-->
<!--                @click="navigateToDetail(item)"-->
<!--              >-->
<!--                {{ getFirstAndLastWordFirstChar(item.currentNameLastName+' '+item.currentNameFirstName) }}-->
<!--              </span>-->
<!--              </div>-->
              <div
                class="col ___disableClickOnMobile"
                style="cursor: pointer"
                @click="navigateToDetail(item)"
              >
                <div class="employee-name">
                  <span v-if="item.currentNameLastName">{{
                    item.currentNameLastName
                  }}</span>
                  <span v-if="item.currentNameFirstName">{{
                    " " + item.currentNameFirstName
                  }}</span>
                  <span
                    v-if="item.exitType === 1 || item.exitType === 2"
                    class="exit-status-text"
                  >
                    -
                    {{
                      item.exitType === 1 ? "kiléptetés alatt" : "kiléptetve"
                    }}
                  </span>
                </div>
                <div class="employee-mothers-name">
                  <span>{{
                    item.employmentMode ? $cte(item.employmentMode.name) : ""
                  }}</span>
                </div>
              </div>
              <div v-if="showExit" class="col-auto d-flex align-items-center justify-content-end">
                <b-button
                  v-if="item.exitType === 0"
                  class="btn-link bg-white p-2 border rounded-circle shadow-lg employee-action"
                  style="background-color: white !important;"
                  aria-label="Kiléptetés"
                  title="Kiléptetés"
                  @click="exitEmployee(item)"
                ><i class="fa-light fa-user-minus" aria-hidden="true"></i></b-button>
<!--                <b-button-->
<!--                  v-if="item.exitType === 1"-->
<!--                  class="btn-link bg-white p-2 border rounded-circle shadow-lg employee-action"-->
<!--                  aria-label="Kiléptetés visszavonása"-->
<!--                  title="Kiléptetés visszavonása"-->
<!--                  @click="reApplyEmployee(item, '-reapply1')"-->
<!--                ><i class="fa-light fa-xmark" aria-hidden="true"></i></b-button>-->
                <b-button
                  v-if="item.exitType === 2"
                  class="btn-link bg-white p-2 border rounded-circle shadow-lg employee-action"
                  style="background-color: white !important;"
                  aria-label="Visszaléptetés"
                  title="Visszaléptetés"
                  @click="reApplyEmployee(item, '-reapply2')"
                ><i class="fa-light fa-rotate-left" aria-hidden="true"></i></b-button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="max-content-width mx-auto mb-2 set-max-width">
          <div class="max-content-width mx-auto mb-2 set-max-width">

          </div>
          <div class="max-content-width mx-auto set-max-width text-overflow">
            {{ $cte(emptyListString) }}
          </div>
        </div>
      </div>

      <Paging
        v-if="enablePagination && rowCount > itemPerPage"
        :item-per-page="itemPerPage"
        :totalRows="rowCount"
        @paging-change="updateTable"
      />
    </b-overlay>

    <b-modal :id="uniqueId + '-exit'" title="Kiléptetés" hide-footer>
      <div class="mb-4">
        <label>Felmondás módja:</label>
        <b-form-select
          v-model="exitDetails.dismissionModeId"
          ref="dismissionModeId"
          :options="dismissionOptions"
        />
        <div
          class="validation-error-msg"
          ref="dismissionModeId-validation-message"
        />
      </div>
      <div class="mb-4">
        <label>{{
          exitDetails.dismissionModeId === 2701
            ? "Utolsó munkában töltött nap"
            : "Munkaviszony megszűnésének napja"
        }}</label
        ><br />
        <date-picker
          v-model="exitDetails.exitTime"
          ref="exitTime"
          :format="'YYYY-MM-DD'"
          valueType="format"
          :lang="lang"
          class="datepicker"
        />
        <div class="validation-error-msg" ref="exitTime-validation-message" />
      </div>
      <div
        v-if="exitDetails.dismissionModeId !== 2701 && exitDetails.dismissionModeId !== 2706"
        class="mb-4"
      >
        <label>Kiléptetés oka:</label>
        <b-form-input v-model="exitDetails.reason" ref="reason" />
        <div class="validation-error-msg" ref="reason-validation-message" />
      </div>
      <div class="mb-4">
        <label>Szabadság elszámolás:</label>
        <b-form-select
          v-model="exitDetails.leaveAccountingId"
          ref="leaveAccountingId"
          :options="leaveAccountings"
        />
        <div
          class="validation-error-msg"
          ref="leaveAccountingId-validation-message"
        />
      </div>
      <div v-if="exitDetails.dismissionModeId === 2703">
        <b-form-checkbox v-model="exitDetails.dismissalPay" class="mt-3"
          >Végkielégítés</b-form-checkbox
        >
      </div>

      <div style="text-align: right" class="mt-5">
        <b-button
          class="mx-2"
          variant="secondary"
          @click="$bvModal.hide(uniqueId + '-exit')"
          >Mégse</b-button
        >
        <b-button class="mx-2" variant="success" @click="handleSave"
          >Mentés</b-button
        >
      </div>
    </b-modal>

    <b-modal
      :id="uniqueId + '-reapply1'"
      title="Kiléptetés visszavonása"
      hide-footer
    >
      <div>
        <label class="mb-0">Munkavállaló neve:</label><br />
        <div class="mb-3">{{ reapplyDetails.currentName }}</div>
      </div>
      <div>
        <label>Kiléptetés visszavonásának oka:</label>
        <b-form-input v-model="reapplyDetails.reason" ref="reason" />
      </div>

      <div style="text-align: right" class="mt-4">
        <b-button
          class="mx-2"
          variant="secondary"
          @click="$bvModal.hide(uniqueId + '-reapply1')"
          >Mégse</b-button
        >
        <b-button
          class="mx-2"
          variant="success"
          @click="handleReapply('-reapply1')"
          >Mentés</b-button
        >
      </div>
    </b-modal>

    <b-modal :id="uniqueId + '-reapply2'" title="Visszaléptetés" hide-footer>
      <div>
        <label class="mb-0">Munkavállaló neve:</label><br />
        <div class="mb-3">{{ reapplyDetails.currentName }}</div>
      </div>
      <div>
        <label>Visszaléptetés dátuma:</label><br />
        <date-picker
          v-model="reapplyDetails.reapplyTime"
          ref="reapplyTime"
          :format="'YYYY-MM-DD'"
          valueType="format"
          :lang="lang"
          class="custom-control"
        />
        <div
          class="validation-error-msg"
          ref="reapplyTime-validation-message"
        />
      </div>
      <div>
        <label>Visszaléptetés oka:</label>
        <b-form-input v-model="reapplyDetails.reason" ref="reason" />
      </div>

      <div style="text-align: right" class="mt-4">
        <b-button
          class="mx-2"
          variant="secondary"
          @click="$bvModal.hide(uniqueId + '-reapply2')"
          >Mégse</b-button
        >
        <b-button
          class="mx-2"
          variant="success"
          @click="handleReapply('-reapply2')"
          >Mentés</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import Api from "@/api/server/index";
import Paging from "./Paging";
import Util from "@/utils/Util";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "EmployeeView",
  components: {
    Paging,
    DatePicker,
  },
  props: {
    itemPerPage: {
      type: Number,
      default: 5,
    },
    apiCallback: {
      type: Function,
    },
    enablePagination: {
      type: Boolean,
    },
    activeCompanyId: {
      type: Number,
    },
    emptyListString: {
      type: String,
    },
    showExit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      offset: 5,
      rowCount: 1,
      employeeData: [],
      loading: false,
      displayNameMaxLength: 25,
      uniqueId: Util.generateRandomStr(),
      dismissionOptions: [],
      leaveAccountings: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      exitDetails: {
        employeeId: null,
        exitTime: null,
        dismissionModeId: null,
        reason: null,
        leaveAccountingId: null,
        dismissalPay: false,
      },
      reapplyDetails: {
        employeeId: null,
        reapplyTime: null,
        reason: null,
      },
    };
  },
  methods: {
    getColorByExitType(str) {
      if (str === 0) {
        return "#b2ec5d";
      }
      if (str === 1) {
        return "#FFA300";
      } else {
        return "#D3D3D3";
      }
    },

    getFirstAndLastWordFirstChar(str) {
      let chars = "";
      let strArr = [];
      if (str) {
        strArr = str.split(" ");
      }
      if (!!strArr && strArr.length > 0) chars = chars + strArr[0].charAt(0);
      if (!!strArr && strArr.length > 1)
        chars = chars + strArr[strArr.length - 1].charAt(0);
      return chars;
    },

    getImgUrl(src) {
      let images = require.context("@/assets/img/", false);
      return images("./" + src);
    },

    navigateToDetail(item) {
      let self = this;
      if (item.activated) {
        self.$router.push("/app/employee/edit/" + item.id);
      }
    },

    updateTable(data) {
      let self = this;

      self.page = data.pagingPage;
      self.offset = data.pagingOffset;

      self.updateEmployeeData();
    },

    updateEmployeeData() {
      let self = this;

      self.loading = true;

      self
        .apiCallback({
          page: self.page,
          size: self.offset,
          companyId: self.activeCompanyId,
        })
        .then((resp) => {
          self.loading = false;
          self.employeeData = resp.data.content;
          self.rowCount = resp.data.totalElements;
        })
        .catch(() => {
          self.loading = false;
          self.$toast.error({
            title: self.$cte("employeeView.queryFailedTitle"),
            message: self.$cte("employeeView.queryFailedMessage"),
          });
        });
    },

    exitEmployee(employee) {
      this.exitDetails = {
        employeeId: employee.id,
        currentName: employee.currentName,
        exitTime: null,
        dismissionModeId: null,
        reason: null,
        leaveAccountingId: null,
        dismissalPay: false,
      };
      this.$bvModal.show(this.uniqueId + "-exit");
    },

    reApplyEmployee(employee, modalId) {
      this.reapplyDetails = {
        employeeId: employee.id,
        currentName: employee.currentName,
        reapplyTime: null,
        reason: null,
      };
      this.$bvModal.show(this.uniqueId + modalId);
    },

    handleReapply(modalId) {
      const { employeeId, reapplyTime, reason } = this.reapplyDetails;
      const payload = {
        employeeId,
        reapplyTime,
        reason,
      };

      Api.reApplyEmployee(payload)
        .then(() => {
          this.$toast.success({
            title: this.$cte("toast.success"),
            message: this.$cte("toast.modify-success"),
          });
          this.$bvModal.hide(this.uniqueId + modalId);
          this.updateEmployeeData();
        })
        .catch((err) => {
          this.$toast.error({
            title: this.$cte("toast.error"),
            message: this.$cte("toast.modify-failed"),
          });
          Util.showValidationErrors(err, this.$refs);
        });
    },

    handleSave(event) {
      event.preventDefault();

      const {
        employeeId,
        exitTime,
        dismissionModeId,
        reason,
        leaveAccountingId,
        dismissalPay,
      } = this.exitDetails;
      const payload = {
        employeeId,
        exitTime,
        dismissionModeId,
        reason: dismissionModeId === 2706 ? null : reason,
        leaveAccountingId,
        dismissalPay,
      };

      Api.exitEmployee(payload)
        .then(() => {
          this.$toast.success({
            title: this.$cte("toast.success"),
            message: this.$cte("toast.modify-success"),
          });
          this.updateEmployeeData();
          Util.clearValidationErrors(
            document.getElementById(this.uniqueId + "-exit")
          );
          this.$bvModal.hide(this.uniqueId + "-exit");
        })
        .catch((err) => {
          Util.clearValidationErrors(
            document.getElementById(this.uniqueId + "-exit")
          );
          Util.showValidationErrors(err, this.$refs);
        });
    },
  },
  created() {
    this.offset = this.itemPerPage ? this.itemPerPage : 5;

    Api.getDismissonModes()
      .then((data) => {
        data.data.content.forEach((item) =>
          this.dismissionOptions.push({
            value: item.id,
            text: this.$cte(item.name),
          })
        );
      })
      .catch((err) => console.error(err));

    Api.getLeaveAccountings()
      .then((data) => {
        data.data.content.forEach((item) =>
          this.leaveAccountings.push({
            value: item.id,
            text: this.$cte(item.name),
          })
        );
      })
      .catch((err) => console.error(err));

    this.updateEmployeeData();
  },
};
</script>

<style lang="scss">
.employee-icon {
  svg {
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.set-max-width {
  max-width: 100%;
}

.rounded-employee-icon {
  width: 50px !important;
  height: 50px !important;
  border-radius: 100%;
  text-align: center;
  line-height: 50px;
  color: #252734;
  cursor: pointer;
  margin-right: 10px;
  padding: 5px !important;
  padding-top: 2px !important;
  display: inline-block;
}

.max-content-width {
  width: max-content;
}

.empty-list-image {
  width: 75px;
}

.activated {
  color: #212529;
}

.employees:not([class*="activated"]) {
  color: #80808f;
}

* {
  transition: 0.3s;
}

.employee-icon {
  width: 50px;
  text-align: center;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}

.employee-name {
  font-size: 16px;
}

.employee-mothers-name {
  line-height: 1.6;
  font-size: 0.8rem;
  color: #7e7e84;
}

.employee-item {
  border: 1px solid #252734;
  border-radius: 32px;
}

.employee-item:hover {
  background-color: #efefef;
  border-color: #efefef;
}

.employee-icon svg {
  width: 100%;
}

.exit-status-text {
  line-height: 1.6;
  font-size: 0.8rem;
}

.employee-action {
  width: 40px;
  height: 40px;
  border-color: #ced4da !important;
}

input, select, .datepicker, .custom-select {
  border-radius: 32px;
  background: rgba(174, 191, 199, 0.50);
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10);
  font-size: 12px;
  padding: 0px 15px !important;
  height: 42px!important;
  color: #252734 !important;
}

</style>
